import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
export default function (_ref) {
  var {
    req,
    $axios
  } = _ref;
  var {
    header = {}
  } = req || {};
  var xMdM = Object.entries(header).filter((_ref2) => {
    var [key] = _ref2;
    return /^x-mdm-/i.test(key);
  });
  $axios.setHeader('correlation-id', header['correlation-id']);
  $axios.setHeader('mdm-client-ip', header['mdm-client-ip']);
  xMdM.forEach((_ref3) => {
    var [key, value] = _ref3;
    return $axios.setHeader(key, value);
  });
}